import { render, staticRenderFns } from "./conoceRiesgos.vue?vue&type=template&id=b4e14192&scoped=true&"
import script from "./conoceRiesgos.vue?vue&type=script&lang=js&"
export * from "./conoceRiesgos.vue?vue&type=script&lang=js&"
import style0 from "./conoceRiesgos.vue?vue&type=style&index=0&id=b4e14192&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4e14192",
  null
  
)

export default component.exports